import {AfterViewInit, Component, ElementRef, Input, OnInit} from '@angular/core';
import * as pbi from 'powerbi-client';
import {ActivatedRoute} from "@angular/router";
import {PowerbiApiService} from "../../services/api/powerbi-api.service";

@Component({
  selector: 'app-power-bi-dashboard',
  templateUrl: './power-bi-dashboard.component.html',
  styleUrls: ['./power-bi-dashboard.component.scss']
})
export class PowerBIDashboardComponent implements OnInit, AfterViewInit {

  companyId;
  config = {
    type: 'report',
    tokenType: pbi.models.TokenType.Embed,
    accessToken: 'H4sIAAAAAAAEAB2Wta7FCpJF_-WlbslMLXVg-5iZITMzs0fz73On84pW1V67_ucfK32HOS3--fc_apUOoWbAjIHIFD3d1d14ulFZGMx0J37XhwTK1fGhldlRECP4YBDzLOHQ1HGm5AU8LPh5aS4Jr6BrjStRIE0Q6wIJh_iVERE9pBm3c-i9TDQb9Gh2iJA7OLlYHThdWrq3xdXX131h9c7KqtADzyYmAOxG1nFpnS85vUsiPT5WTMaQ7z1kOydhTm2xxsX4r_RRp5uavPI-1fOT953YWE7i4W6sn_ocXlWdFa67zYza8FwnwkPf7sg1Gjf65BAw5a7jMRyY37cOAMZOqR9u_SZKccOTXbSWWq_EuSSjYOx3S894sgmGzh6YaXJ6ZxvTIAoulRTl4iP0IgZqAEEoB4pHO68zDJH9ewPktYJPaEiujxf917y-xywTLyy5xVjzA4H206wwSHU__0TnCT1g4Z3Qn4xS_oiy0eyUd-fT8N2v9colkpfj01MGT1j8TGuCNO2ZHo9Br9LO5LBGNqbUcWl8CULguiyCrh7LEXIQnSjLtMQdGIxwGjh9HQ67ynvrNxr7RLIMfNhtm9RFjWvtb8mdIGYHt1hJ85IAP-urHxSTubFMjcMWePPkAVUK4Afr6ZOHXXtroPHoIKWDBNeqHV1iVPudHAhCGgE13DBi-sihYfrJHzoPZYVQUeXt8ZuKSQzJPEqW99PKYvCCD7Bye3Yi4hd66TAMqNJfzbmek-bbpqThJG9C1TRis1tbQKpgaR_BscYZyf4ViL7agX2mj20GH_T8Rg2TwHM_N2pSlfJsb4CvoPGLqRU7hh6LH9mly4ouLLpSKbPgexJ2qdAO0IEWNG1Vu6Ekw4up2RXQmZgjGuMY_P5kVsAkTRC-uvwEPAK7gbOxwNHwd0JYPwJgcDaMKkeN1R_GKWe3a2VX2c6FyaQ5fttIYKaQjVq_crv4q--Q5WTdMxp24VBGxBufXNgaosLhmEcPF64cIRoRJqXjbPgTaC-i5VqhP3fH2KmuHEihKBaJYmJtZX8039HU2FD72OWQWs1XDobgkjd4OARPq0XcWQSM1CsQhBOXIzwLM8l8SuPAqLrSbqSLIdkCSlWeLGC751HPb1vx1tta-Jcb5sZMtCV4TBuUUa8IwXQeBRmKqTL0IItzZK_PbsKvMdGTF4_G50foRkvSYDGvqrGzbxZ8dZINMCn20Ocbw8RR65fDPskndcCxAyYlnlj6B7aMnaL70Bh4KDgLFzQ9Z8_gEJa8BV2t2CU023FwPQ3quDoPd6cQfIkWdcpVfZK261vYhjXaM5sjOBonkfBI5ViudLECXz4amHYwzGZxgAepeRNz3spKqWjn5jbQTUVBGDERlZqfmtKrFcyymzg9yxN5KYIYwGIXd-dwCr-5jhFUINaIWivuyPCxE0bQr2z6M2ZG6K8OO-iydDgyaVgUidS5PbDwwSlLTABUT8kEBYGBYYxfZJqJmIz17rcA0FUAZImTt649ceRES2BXRJxSclAtOY3EIQ_jv4JC4kkTpxDalDB2PzhB3EVsD6Q8ebr-ZXbuCu0Utffquvbz9T-vu6Vb9LoV-zka5Q_NUjD5m_Nf3BTaz6RQGgLWBqPTUvw7RtaQk3qiEDsgGSLXtTOHk4b85jivgSq2fW_DnT7igaMWyspdbHc1caOVBjV2LWOon_Tdc9nJfrQh9evqL7PgOZMI2E4983Otk2WLJi694QaDwWTDGIs3TO166DpfSjeYIkMqMj2qg1PkFF_Zn1JmL-GPIvSC-VFMcm2MePwpztjyE4mlke11vcswRMKvV3FyEmdG3Fryx78OcxP7hperIhGv3PNme0U-Sn2xJ-GicflBGs9uvPw2_PwnPP236oolKFTojE_Enjo8rjFVQlUNbbp46VaWUORJCDin0rgZqzf8svrVFoi7-w9yZtmCEulL2h5Uy3tpQng6LAxSHh8c3X5J2xU9zrXLP250iEAwIomWF2Z15wPWaCjYOnH8k2gHm64lUgEck-5GJvb_j_vq-7hBnTeNcwqe8S2y_nIJRZBPqXUjqc_scln9MHKNw-lMwHCe1009Pq7mnuezcT8Ll_CSL8lfPxxGiWokDPuYLQJAO2B5RchXWLxPfWd6qMoqbb0W9hqr7Ij28hdzwzDIX17RfWxkK4XU_FKsJKVjJSO1RjO6-_xYL9p8VV1HfzUiC2LyHqSZriXuEx8F_uVMoELfnS8p7tZ37gP23Su6PCNS_zAwygV1wNDqUmYyyBwmonlORcbkycas-DKBf3SUYZlNVGt-2gajeDYlvTvK1h-5F-G5tV6VKpWRqjU0I1y5r6wbuhr_rZnlCrnXgb3BrB5ykld9W1qKpKxL4cdM-dvRnK3Hjk0GXgc5kRSOk0TbNeyZwNXd3QFKkBs-tQdNu0vU3ltLI5vHy-cF8TtNnjFGY79svfodP1lHZGj3RaZttQYFqbYqH5paHIO7PWAxKczLQrZk2Br2mP_8869_uO1djlkt37_XS1uWu7tAbaXVSS4n9wggDc4z2zFiCMizpDSa1W2MzCDpexZUuJTahEDjPGnrDgfcW0SJe7qxQioag_qjoJJcUt_F4axQw3FagtOn0GLhPZoqWcTrJtl_UpeRF0NTZmLJHulqQ5bTvcwsmtE4wKADY2azxvLTRPt6v9w2IFq8trqsMQOZZ7EqjTB2MmWZnjKh0F-L7Lm8BJ3XSJxYNv2JgKyy-8-DCDsZq_gpyZsKBhRlFjMUfOJN0JjLlWsa7mN6Y6Vg346PEN-7cIHwL0OdzBRyf35DMUST8s2X_cVtUY3vAgQWal3qrzqp7SzM4UtpfYWJqElos47spLZVD_vz5I7d__kv5ndpyk0O_igHUzXDdN9Vml9fI5P2ek069X-n3Lae0uPcyr8x5nXoxUNPjg3qC3IG3R4n-MZNA5vBrUgfUswCpQYlRPwrDfhJ3QwqNjQW9XW0J8wkNRjZlkizwCchE9yO9L7-uid2WofuI7BmCqM_AH5bQAmH0tjPIeEq_z6WmG7dARmmNTIpe9WIjE_R6wSFlRcXuXzpgAzqhrHNgkxTIAiD51OVoZFVGPANnv7yDLQ7ho1n8kiQiPpD9MvSJjU3aUXTU58Xi_0I5ZfR993rPsG-J40n90nhmE7J20rUDG8EHuiJcTB0LoVhZlK7mlorUQG0Hp0hmn6ITakbRvinlKlmj3lvcUxtS6wP4BByN3WHrn1Q6xgX3qASh3aSKvBrWkTjmJP5w_y__wdI5tSibgwAAA==.eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLU5PUlRILUNFTlRSQUwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7Im1vZGVybkVtYmVkIjpmYWxzZX19',
    embedUrl: 'https://app.powerbi.com/dashboardEmbed?dashboardId=b5f50796-6e97-4dc5-a755-00cf4405e029&groupId=be8908da-da25-452e-b220-163f52476cdd&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLU5PUlRILUNFTlRSQUwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7Im1vZGVybkVtYmVkIjpmYWxzZX19',
    id: '',
    pageView: 'fitToWidth',
    permissions: pbi.models.Permissions.All,
  };
  dashboard;
  dashboardContainer;
  powerBi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
  iframe;
  company;

  constructor(
    private route: ActivatedRoute,
    private powerBiAPI: PowerbiApiService,
    private elementRef: ElementRef
  ) { }

  ngOnInit(): void {
    this.company = JSON.parse(localStorage.getItem('company'));
    if (this.company.powerBiKey && this.company.powerBiKey !== "" && this.company.powerBiKey !== null) {
      const powerBI = JSON.parse(this.company.powerBiKey);
      const myElement = document.getElementById('dashboardPowerBi');
      if (powerBI.dashboard && powerBI.dashboard !== "" && powerBI.dashboard !== null) {
        this.powerBiAPI.getReport(powerBI.groupID, powerBI.dashboard).subscribe((res: any) => {
          this.config.embedUrl = res.embedUrl;
          this.config.accessToken = res.embedToken;
          this.config.id = res.dashboardId;
          this.dashboard = this.powerBi.embed(myElement, this.config);
          this.iframe = document.querySelector('iframe');
          this.iframe.style.border = '0px';
          // setTimeout(() => {
          //   this.checkIframeLoaded();
          // }, 5000)
        });
      }
    }
    this.companyId = this.route.snapshot.paramMap.get("companyId");
  }

  // checkIframeLoaded() {
  //   const _this = this;
  //   const iframe: HTMLIFrameElement = document.querySelector('#dashboard > iframe');
  //   // iframe.setAttribute("onload", "afterLoading()");
  //   iframe.addEventListener("load", _this.afterLoading());
  //   window.setTimeout(this.checkIframeLoaded, 100);
  // }
  //

  ngAfterViewInit() {
    window.addEventListener("message", (m) => {
      // console.log(m);
      if (m.origin ==='https://app.powerbi.com') {
        this.iframe.style.height = `${m.target['innerHeight']}px`;
      }
    });
    setTimeout(() => {
      window
        .addEventListener('DOMContentLoaded', () => {
          var iframes: any = document.querySelectorAll("iframe");
          for (var i = 0; i < iframes.length; i++) {
            this.resizeIFrameToFitContent(iframes[i]);

            iframes[i].attributes.removeNamedItem("style");

            alert(iframes[i].parentNode.id);

          }
        });
    }, 5000);
  }

  afterLoading(){
    // console.log("Dashboard Loaded");
  }

  fullscreen() {
    this.dashboard.fullscreen();
  }

  resizeIFrameToFitContent(iFrame) {

    var reportContainer = document.getElementById('reportContainer');

    iFrame.width = reportContainer.clientWidth;
    iFrame.height = reportContainer.clientHeight;

  }
}

